<template>
  <div class="parent-box">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <br />
          <br />

          <div class="modal-container">
            <div class="modal-header">
                          <h1 class="close-btn" @click="$emit('close')">Close</h1>

            </div>
              <div class="modal-body">
                <div class="heading">
                <slot name="header"></slot>
                 </div>
                 <div class="container" style="width: 100%">
                     <slot name="body"></slot>
                 </div>
                 </div>
            </div>


               
                    
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'Modal',
  props: {
    productDetails: null,
    titleProduct: null,
    amt: null,
    desc: null,
  },
  components: {

  },
  computed: {},
  data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: '',
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
       BT: [
        { id: 'Oil & Gas', name: 'Oil & Gas' },
        { id: 'Farmer', name: 'Farmer' },
                { id: 'Driver', name: 'Driver' },
                                { id: 'Painter', name: 'Painter' },



      ],
      employmentStatus: [
        { id: 'Employed', name: 'Employed' },
      ],
      incomes: [
        { id: '< N500,000', name: ' < N500,000' },
        { id: '>N500,000 and < N750,000', name: '>N500,000 and < N750,000' },
        {
          id: '> N750,000 and < N1,000,000',
          name: '> N750,000 and < N1,000,000',
        },
        { id: '> N1,000,000', name: '> N1,000,000' },
      ],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: '',
        income: '',
        employment: '',
        business: '',
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {},
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success',
      title: 'Success',
      message: 'Success Msg!',
    },
    showInfoMsg: {
      type: 'info',
      title: 'Information',
      message: 'Info. Msg!',
    },
    showWarnMsg: {
      type: 'warning',
      title: 'Warning',
      message: 'Warning Msg!',
    },
    showErrorMsg: {
      type: 'error',
      title: 'Error',
      message: 'Error Msg!',
    },
  },

  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    },
    
  },
  async mounted() {
    
  },
}
</script>

<style lang="scss" scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.amt {
  font-size: 20px;
  font-weight: bold;
}

.info-below {
  font-size: 16px;
  font-weight: 900;
}

.info-footer {
  float: left;
  margin-bottom: 3rem;
}

.modal-container {
  width: 550px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  margin-top: 0;
  color: #42b983;
  position: relative;
  .close-btn {
    color: orangered;
    font-size: 16px;
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 6px;
  border: 0;
  margin-right:15px;
  font-weight: bold;
  background: #ffb946;

  &:hover {
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customer-admin/Modal.vue